import * as React from 'react';
import { Button, Icon, Menu, Card, Col, Row } from 'antd';
import autobind from 'autobind-decorator';
import { observable } from 'mobx';
import { observer } from 'mobx-react';

import { DocumentTemplateCategoryEditorController } from 'src/app/general/document-template-categories/parts/document-template-category-editor.controller';
import { Column, DataTableView, ToolbarVisibility } from 'src/core/ui/data-table.view';
import { DropdownView } from 'src/core/ui/dropdown.view';
import { LanguageEditorController } from 'src/app/general/language/parts/language-editor.controller';

interface DocumentTemplateSearchViewProps extends ComponentViewProps<DataSet<IDocumentTemplateSummary>> {
	generateDocument: (targetId: number, usage: string, templateId: number, format: string, exportLanguage: string) => void;
	mode: ControlMode;
	setBusy(isBusy: boolean);
	categoryId?: number
	filterData: (categoryId: number) => void;
	usage: string;
	idModel: number;
	categories: DocumentTemplateCategorySummary[];
}

@observer
export class DocumentTemplateSearchView extends React.Component<DocumentTemplateSearchViewProps, any> {
	columns: Column[] = [
		{
			title: 'Name',
			key: 'displayName',
			dataIndex: 'displayName'
		},
		{
			title: '',
			key: 'download',
			render: (value: any, record: IDocumentTemplateSummary) => {
				return (
					<Button
						icon="download"
						onClick={() => this.props.generateDocument(this.props.idModel, this.props.usage, record.id, this.type, this.language)}>
					</Button>
				);
			}
		}
	];

	@observable
	language: string;

	@observable
	type: string = 'PDF';

	@observable
	categoryId: number

	@observable
	categories: DocumentTemplateCategorySummary[] = [];

	constructor(props) {
		super(props);
		this.categoryId = this.props.categoryId;
		this.categories = this.props.categories;
	}

	componentWillReceiveProps(nextProps: Readonly<DocumentTemplateSearchViewProps>, nextContext: any): void {
		if (nextProps.categoryId != this.categoryId) {
			this.categoryId = nextProps.categoryId;
		}
	}

	@autobind
	handleClick(e) {
		let id = parseInt(e.key);
		this.props.filterData(id);
	}

	render() {
		if (this.props.model == null) {
			return null;
		}
		let optionsMode = [
			{ value: 'PDF', label: 'PDF' },
			{ value: 'EXCELOPENXML', label: 'EXCEL' },
			{ value: 'WORDOPENXML', label: 'WORD' }
		];
		let panels = this.categories.map(x => (
			<Menu.Item key={x.id.toString()}>
				{x.displayName}
			</Menu.Item>
		));
		return (
			<Row gutter={16}>
				<Col xs={24} lg={8}>
					<Card title="Categories">
						<Menu
							onClick={this.handleClick}
							mode="vertical">
							{panels}
						</Menu>
					</Card>
				</Col>
				<Col xs={24} lg={16}>
					<DataTableView
						toolbarLeftItems={
							<Row gutter={16}>
								<Col xs={24} lg={12}>
									<DropdownView
										disabled={this.props.mode == 'display'}
										label={'Format'}
										model={this.type}
										onChanged={(item) => this.type = item.value}
										options={optionsMode}
									/>
								</Col>
								<Col xs={24} lg={12}>
									<LanguageEditorController
										label='Language'
										mode={this.props.mode}
										value={this.language}
										setBusy={this.props.setBusy}
										onChanged={newval => this.language = newval}
									/>
								</Col>
							</Row>
						}
						setBusy={this.props.setBusy}
						columns={this.columns}
						model={this.props.model}
						hideToolbar={ToolbarVisibility.hideSearch | ToolbarVisibility.hideModifyButtons}
					/>
				</Col>
			</Row>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/document-template-search/document-template-search.view.tsx